'use client';

import { BlurSwap } from '../../collection-showcase/scenes/playback-controls.jsx';
import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import {
  Wi,
  Fi,
  Ii,
  zi,
  Gi,
  Bi,
  Li,
  Vi,
  Hi,
  Ui,
  StressTest,
} from './stress-test';
import { Ir, Pr, Rr } from './apps-animation';
import { WorkbookWindow, WorkbookGrid } from './workbook-grid';
import { CashForecast } from './cash-forecast';
import { CollectionEconomics } from './collection-economics';
import { xe } from './business-facts';
export function Ki(e) {
  return [
    {
      head: !0,
      cells: [
        {
          v: 'Inputs',
        },
        {
          v: 'Value',
        },
        {
          v: '',
        },
        {
          v: '',
        },
      ],
    },
    Wi('Units', Fi.order.units, Ir, 240, Fi.order.buyer.toLowerCase()),
    Wi('Wholesale / unit', Ii.pricePerUnit, Pr, 380, 'assumed'),
    Wi('Variable cost / unit', Ii.variableCostPerUnit, Pr, 520, 'assumed'),
    Wi('Order costs', Ii.orderCosts, Pr, 660, 'assumed', !0),
    Wi(
      'Allowance',
      Ii.allowance * 100,
      (e) => `${Math.round(e)}%`,
      800,
      'assumed',
      !0
    ),
    Wi(
      'Deposit',
      Fi.order.deposit * 100,
      (e) => `${Math.round(e)}%`,
      940,
      Fi.order.terms
    ),
    {
      head: !0,
      cells: [
        {
          v: 'Economics',
        },
        {
          v: 'Baseline',
        },
        {
          v: e ? 'Stress' : '',
        },
        {
          v: '',
        },
      ],
    },
    ...Fi.rows.map((t, n) => {
      let r = zi(t.unit),
        i = e
          ? {
              n: t.stress,
              fmt: r,
              at: 4300 + n * 440,
              f: Gi[n]?.replaceAll(/B(9|1[0-3])\b/g, 'C$1'),
              tone: 'warn',
              bold: !0,
            }
          : {};
      return {
        cells: [
          {
            v: t.metric,
            at: 1300 + n * 380,
          },
          {
            n: t.baseline,
            fmt: r,
            at: 1500 + n * 380,
            f: Gi[n],
          },
          i,
          {},
        ],
      };
    }),
  ];
}
export function MarginGauge({ value: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = -90 + e * 180;
  return (
    <svg
      viewBox={'0 0 64 38'}
      aria-hidden={!0}
      className={'h-[38px] w-16 shrink-0 overflow-visible'}
    >
      <path
        d={'M6 34a26 26 0 0 1 52 0'}
        fill={'none'}
        stroke={'var(--border)'}
        strokeWidth={'4'}
        strokeLinecap={'round'}
      />
      <path
        d={'M6 34a26 26 0 0 1 52 0'}
        fill={'none'}
        stroke={'var(--ref-violet)'}
        strokeWidth={'4'}
        strokeLinecap={'round'}
        pathLength={1}
        strokeDasharray={'1 2'}
        strokeDashoffset={1 - e}
        className={'ring-fill'}
      />
      {translateShowcaseNode(
        showcaseCopy,
        Array.from(
          {
            length: 11,
          },
          (e, t) => {
            let n = ((-90 + t * 18) * Math.PI) / 180,
              r = t % 5 == 0 ? 15 : 17;
            return (
              <line
                key={t}
                x1={32 + Math.sin(n) * 19.5}
                y1={34 - Math.cos(n) * 19.5}
                x2={32 + Math.sin(n) * r}
                y2={34 - Math.cos(n) * r}
                stroke={'var(--muted-foreground)'}
                strokeWidth={'1'}
                opacity={0.6}
              />
            );
          }
        )
      )}
      <g
        style={{
          transform: `rotate(${t}deg)`,
          transformOrigin: '32px 34px',
          transition: 'transform 700ms var(--ease)',
        }}
      >
        <line
          x1={'32'}
          y1={'34'}
          x2={'32'}
          y2={'14'}
          stroke={'var(--foreground)'}
          strokeWidth={'1.75'}
          strokeLinecap={'round'}
        />
      </g>
      <circle cx={'32'} cy={'34'} r={'2.5'} fill={'var(--foreground)'} />
    </svg>
  );
}
export function WholesaleDecision({ deposit: e, stamped: t, checked: n }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div
      className={
        'enter pop rounded-2xl p-1.5 lg:absolute lg:top-3 lg:right-3 lg:w-[284px]'
      }
    >
      <div className={'rounded-[10px] p-3'}>
        <p className={'text-ink-3 flex items-center gap-2 text-[12px]'}>
          <ShowcaseIcon name={'doc'} className={'size-4'} />
          {translateShowcaseNode(
            showcaseCopy,
            'Decision \xB7 order acceptance memo'
          )}
        </p>
        <div className={'mt-3 flex items-center gap-3'}>
          <MarginGauge value={e} />
          <div className={'min-w-0'}>
            <p className={'text-ink-3 text-[12px] leading-4'}>
              {translateShowcaseNode(showcaseCopy, 'Deposit to avoid a gap')}
            </p>
            <p
              className={
                'num text-ink text-[20px] leading-7 font-semibold tracking-[-0.01em]'
              }
            >
              <BlurSwap value={`${Math.round(e * 100)}%`} />
            </p>
            <p className={'num text-ink-4 text-[12px] leading-4'}>
              {translateShowcaseNode(showcaseCopy, 'Offered: 50%, net 60')}
            </p>
          </div>
        </div>
        <div className={'mt-4 min-h-[34px]'}>
          {translateShowcaseNode(
            showcaseCopy,
            t ? (
              <span
                className={
                  'bz-stamp inline-flex origin-left items-center rounded-md px-2.5 py-1.5 text-[13px] leading-[18px] font-semibold text-[var(--ref-violet)] shadow-[inset_0_0_0_1.5px_var(--ref-violet)]'
                }
              >
                {translateShowcaseNode(showcaseCopy, Fi.recommendation)}
              </span>
            ) : (
              <span
                className={'text-ink-4 flex h-[34px] items-center text-[13px]'}
              >
                {translateShowcaseNode(
                  showcaseCopy,
                  'Weighing margin and cash\u2026'
                )}
              </span>
            )
          )}
        </div>
        <p className={'text-ink-3 mt-2 text-[12.5px] leading-[1.45]'}>
          {translateShowcaseNode(showcaseCopy, Fi.why)}
        </p>
        <p
          className={`text-ink-2 mt-2 flex min-h-4 items-center gap-1.5 text-[12px] leading-4 transition-opacity duration-300 ${n ? 'opacity-100' : 'opacity-0'}`}
        >
          {translateShowcaseNode(
            showcaseCopy,
            n ? (
              <ShowcaseIcon
                name={'check'}
                draw={'now'}
                className={'size-3.5 shrink-0'}
                strokeWidth={2}
              />
            ) : null
          )}
          {translateShowcaseNode(showcaseCopy, Fi.checks)}
        </p>
      </div>
    </div>
  );
}
export function WholesaleOrder({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = e >= Bi,
    n = Ki(t),
    r = Rr(n, e, 340);
  return (
    <WorkbookWindow
      title={translateShowcaseNode(
        showcaseCopy,
        'Department store order, 400 units'
      )}
      version={'v1'}
      file={'Wholesale-order.sheet'}
      tabs={Fi.sheets}
      activeTab={t ? 5 : 2}
      formula={r}
      approved={e >= 8300}
    >
      <WorkbookGrid
        label={'Wholesale order economics'}
        columns={Li}
        rows={n}
        t={e}
        pick={r}
        extra={8}
        minRows={13}
      />
      <div className={'m-2 min-h-[300px] lg:contents'}>
        {translateShowcaseNode(
          showcaseCopy,
          e >= 5200 ? (
            <WholesaleDecision
              deposit={e >= Vi ? 0.667 : Fi.order.deposit}
              stamped={e >= Hi}
              checked={e >= Ui}
            />
          ) : null
        )}
      </div>
    </WorkbookWindow>
  );
}
export const Xi = 8600;
export const Zi = [
  {
    name: 'Evaluate a Wholesale Order',
    icon: 'store',
    render: (e) => <WholesaleOrder t={e} />,
  },
  {
    name: 'Forecast Cash',
    icon: 'clock',
    render: (e) => <CashForecast t={e} />,
  },
  {
    name: 'Stress-Test the Plan',
    icon: 'zap',
    render: (e, t) => <StressTest t={e} onInteract={t} />,
  },
  {
    name: 'Check Collection Economics',
    icon: 'tag',
    render: (e) => <CollectionEconomics t={e} />,
  },
];
export const FinanceWorkflow = React.memo(function FinanceWorkflowPreview({
  index: e,
  t,
  onInteract: n,
}) {
  return <React.Fragment>{Zi[e]?.render(t, n)}</React.Fragment>;
});
export const $i = (e) => xe.workflows.find((t) => t.name === e)?.does ?? '';
export const ta = () => {};
